import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  aboutUs,
  contactUs,
  helpUs,
  newsLetterSubscription,
} from "../redux/newsLetter/actions";
import Spinner from "react-bootstrap/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
import "./FooterNewB2C.scss";
import Loader from "./Loader/Loader";
import FooterCustomModal from "./FooterCustomModal";
import useLogin from "../custom-hooks/useLogin";
import { SessionKeys } from "../utils/AppUtils";
import { useTranslation } from "react-i18next";

export default function FooterNewB2C() {
  const location = useLocation();
  let navigate = useNavigate();
  const [showModal, setShowModal] = React.useState(false);
  const [showModalContact, setShowModalContact] = useState(false);
  const [showModalHelp, setShowModalhelp] = useState(false);
  const userRole = useSelector((state) => state.user.role);
  const { t } = useTranslation();
  const { isLoggedIn } = useLogin();

  useEffect(() => {
    console.log("pathname:", location.pathname);
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  const authBroker = useSelector((state) => state.auth.authBroker);

  const newsLetter = useSelector(
    (state) => state.newsLetter.newsLetterSubscriptionResponse
  );
  console.log("news Letter", newsLetter);

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [apiCalled, setapiCalled] = useState(false);
  const [aboutUsCalled, setAboutUsCalled] = useState(false);
  const [contactUsCalled, setContactUsCalled] = useState(false);
  const [helpUsCalled, setHelpUsCalled] = useState(false);

  const activeLanguage = useSelector((state) => state.home.activeLanguage);

  const dispatch = useDispatch();

  const subscribeNewsLetter = (event) => {
    console.log("event", event);
    event.preventDefault();
    setapiCalled(true);
    dispatch(
      newsLetterSubscription({
        module: "newsLetterSubscription",
        postData: {
          email_id: email,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  const aboutUsResponse = useSelector((state) => state.newsLetter.aboutUs);

  const [aboutUsData, setAboutUsData] = useState([]);
  const [contactUsData, setContactUsData] = useState([]);
  const [helpUsData, setHelpUsData] = useState([]);

  useEffect(() => {
    if (aboutUsResponse?.status === "success" && aboutUsCalled) {
      setAboutUsData(aboutUsResponse.payload[0]);
      setIsLoading(false);
      setShowModal(true);
    }
  }, [aboutUsResponse]);

  const contactUsResponse = useSelector((state) => state.newsLetter.contactUs);
  console.log("about---", contactUsResponse);

  useEffect(() => {
    if (contactUsResponse?.status === "success" && contactUsCalled) {
      setContactUsData(contactUsResponse.payload[0]);
      setIsLoading(false);
      setShowModalContact(true);
    }
  }, [contactUsResponse]);

  const helpUsResponse = useSelector((state) => state.newsLetter.helpUs);
  console.log("about---", helpUsResponse);

  useEffect(() => {
    if (helpUsResponse?.status === "success" && helpUsCalled) {
      setHelpUsData(helpUsResponse.payload[0]);
      setIsLoading(false);
      setShowModalhelp(true);
    }
  }, [helpUsResponse]);

  const getAboutUs = () => {
    setShowModal(true);
    // setAboutUsCalled(true);
    // setIsLoading(true);
    // dispatch(
    //   aboutUs({
    //     module: "getAboutUs",
    //     postData: {},
    //   })
    // );
  };

  const getContactUs = () => {
    setShowModalContact(true);
    // setContactUsCalled(true);
    // setIsLoading(true);
    // dispatch(
    //   contactUs({
    //     module: "getContactUs",
    //     postData: {},
    //   })
    // );
  };

  const getHelpUs = () => {
    setShowModalhelp(true);
    // setHelpUsCalled(true);
    // setIsLoading(true);
    // dispatch(
    //   helpUs({
    //     module: "getHelpUs",
    //     postData: {},
    //   })
    // );
  };

  const [termsCalled, setTermsCalled] = useState(false);
  const [getPrivacyCalled, setGetPrivacyCalled] = useState(false);
  const [getCookiesCalled, setGetCookiesCalled] = useState(false);
  const getTerms = () => {
    setTermsCalled(true);
    // setHelpUsCalled(true);
    // setIsLoading(true);
    // dispatch(
    //   helpUs({
    //     module: "getHelpUs",
    //     postData: {},
    //   })
    // );
  };

  // useEffect(() => {
  //   getAboutUs();
  //   // getContactUs();
  //   // getHelpUs();
  // }, [showModal]);

  useEffect(() => {
    if (newsLetter?.status === "success" && apiCalled) {
      setMessage(newsLetter?.payload?.message);
      setapiCalled(false);
      setTimeout(() => {
        setMessage("");
        setEmail("");
      }, 5000);
    }
  }, [newsLetter]);

  return (
    <>
      <Loader start={isLoading} />
      <section
        id="idFooter"
        className="footersection"
        style={{
          marginLeft: location.pathname.includes("/courseDetail/")
            ? "26.25rem"
            : "0px",
        }}
      >
        <footer className="container">
          <div className="row footertop-sec">
            <div className="col-lg-8 col-md-12 ft-leftsec">
              <img
                src="/images/halifax-logo-new.svg"
                className="footer-logo"
                width={150}
                alt="halifax"
              />
              <ul>
                {userRole === "instructor" || userRole === "host" || true ? (
                  ""
                ) : (
                  <li onClick={() => navigate("/our-partners")}>
                    {authBroker?.payload?.user?.config?.partner_menu_text !==
                      undefined &&
                    !_.isEmpty(
                      authBroker?.payload?.user?.config?.partner_menu_text
                    )
                      ? authBroker?.payload?.user?.config?.partner_menu_text
                      : "Partners"}{" "}
                  </li>
                )}
                {userRole != "customer" &&
                userRole != "instructor" &&
                !authBroker?.payload?.user?.display_subscription_menu &&
                localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ? (
                  ""
                ) : userRole === "instructor" || userRole === "host" ? (
                  ""
                ) : (
                  <li onClick={() => navigate("/subscription")}>
                    Xsel Subscriptions
                  </li>
                )}
                {false && (
                  <>
                    {" "}
                    <li
                      onClick={() =>
                        !isLoggedIn ||
                        authBroker.payload?.user.role.includes("customer")
                          ? getAboutUs()
                          : window.open(
                              "https://www.xsel.app/about-us.html",
                              "_blank"
                            )
                      }
                    >
                      About
                    </li>
                    <li
                      onClick={() =>
                        !isLoggedIn ||
                        authBroker.payload?.user.role.includes("customer")
                          ? getContactUs()
                          : window.open(
                              "https://www.xsel.app/contact.html",
                              "_blank"
                            )
                      }
                    >
                      Contact Us
                    </li>
                    <li
                      onClick={() =>
                        !isLoggedIn ||
                        authBroker.payload?.user.role.includes("customer")
                          ? getHelpUs()
                          : window.open(
                              "https://www.xsel.app/contact.html",
                              "_blank"
                            )
                      }
                    >
                      Help
                    </li>
                  </>
                )}
              </ul>
            </div>
            <div className="col-lg-4 col-md-12 ft-rightsec">
              <p className="getgreat-bar">
                {t("Get great insights to your inbox")}
              </p>
              <form
                className="Subscribeform-sec"
                onSubmit={subscribeNewsLetter}
              >
                <div className="Subscribeform">
                  <div className="col-auto-frm">
                    <label
                      htmlFor="inputPassword2"
                      className="visually-hidden"
                    ></label>
                    <input
                      type="email"
                      className="form-control"
                      id="inputPassword2"
                      value={email}
                      placeholder={t("Enter your email")}
                      onChange={(evt) => setEmail(evt.target.value)}
                      title={t("emailFormatHint").replace("{{email}}", email)}
                    />
                  </div>
                  <div className="col-auto-frm">
                    <button
                      type="submit"
                      className={`subscribe-btn ${
                        _.isEmpty(email) ? "cursor-not-allowed" : ""
                      }`}
                      disabled={_.isEmpty(email) ? true : false}
                    >
                      {apiCalled ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        t("Subscribe")
                      )}
                    </button>
                  </div>
                </div>
                {message ? <span className="mt-1">{message}</span> : ""}
              </form>
            </div>
          </div>
          <div className="footerbottom-sec">
            <div className="row">
              <div className="col-md-7 col-12 fb-leftsec">
                <p>
                  © {new Date().getFullYear()} NIIT Inc & Anderna Group{" "}
                  {t("All rights reserved")}.
                </p>
              </div>
              <div className="col-md-5 col-12 fb-rightsec">
                <ul>
                  <a
                    className="footerhlinlk"
                    onClick={() => {
                      navigate("/terms");
                      // !isLoggedIn ||
                      // authBroker.payload?.user.role.includes("customer")
                      //   ? getTerms()
                      //   : window.open(
                      //       "http://www.xsel.app/terms-of-service/",
                      //       "_blank"
                      //     )
                    }}
                  >
                    {t("Terms")}
                  </a>
                  {/* <li
                    onClick={() =>
                      !isLoggedIn ||
                      authBroker.payload?.user.role.includes("customer")
                        ? getTerms()
                        : window.open(
                            "http://www.xsel.app/terms-of-service/",
                            "_blank"
                          )
                    }
                  >
                    Terms
                  </li> */}
                  <a
                    className="footerhlinlk"
                    onClick={() => {
                      navigate("/privacy");
                      // !isLoggedIn ||
                      // authBroker.payload?.user.role.includes("customer")
                      //   ? setGetPrivacyCalled(true)
                      //   : window.open(
                      //       "http://www.xsel.app/privacy-policy/",
                      //       "_blank"
                      //     )
                    }}
                  >
                    {t("Privacy")}
                  </a>
                  {/* <li
                    onClick={() =>
                      !isLoggedIn ||
                      authBroker.payload?.user.role.includes("customer")
                        ? setGetPrivacyCalled(true)
                        : window.open(
                            "http://www.xsel.app/privacy-policy/",
                            "_blank"
                          )
                    }
                  >
                    Privacy
                  </li> */}
                  {/* <li
                    onClick={() =>
                      !isLoggedIn ||
                      authBroker.payload?.user.role.includes("customer")
                        ? getCookiesCalled(true)
                        : window.open(
                            "http://www.xsel.app/cookie-policy/",
                            "_blank"
                          )
                    }
                  >
                    Cookies
                  </li> */}

                  <a
                    className="footerhlinlk"
                    onClick={() => {
                      navigate("/cookie");
                      // !isLoggedIn ||
                      // authBroker.payload?.user.role.includes("customer")
                      //   ? setGetCookiesCalled(true)
                      //   : window.open(
                      //       "http://www.xsel.app/cookie-policy/",
                      //       "_blank"
                      //     )
                    }}
                  >
                    {t("Cookies")}
                  </a>
                </ul>
              </div>
            </div>
          </div>

          <FooterCustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            iframeUrl={"https://www.xsel.app/about-us.html"}
            // title={aboutUsData?.title?.rendered}
            // description={aboutUsData?.content?.rendered}
          />

          <FooterCustomModal
            showModal={showModalContact}
            setShowModal={setShowModalContact}
            iframeUrl={"https://www.xsel.app/contact.html"}
          />
          <FooterCustomModal
            showModal={showModalHelp}
            setShowModal={setShowModalhelp}
            iframeUrl={"https://www.xsel.app/contact.html"}
          />
          <FooterCustomModal
            showModal={termsCalled}
            setShowModal={setTermsCalled}
            iframeUrl={"http://www.xsel.app/terms-of-service/"}
          />
          <FooterCustomModal
            showModal={getPrivacyCalled}
            setShowModal={setGetPrivacyCalled}
            iframeUrl={"http://www.xsel.app/privacy-policy/"}
          />
          <FooterCustomModal
            showModal={getCookiesCalled}
            setShowModal={setGetCookiesCalled}
            iframeUrl={"http://www.xsel.app/cookie-policy/"}
          />
        </footer>
      </section>
    </>
  );
}
